import Select from "react-select";
import CustomBadge from "@/components/desktop/badge/CustomBadge";
import CustomButton from "@/components/desktop/button/CustomButton";
import { X, Leaf, Sprout } from "lucide-react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import { formatMilesDecimalNew, decimalValidateNew } from "@/services/Utils";
import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

import styles from "./ApplicationOrderBusinessCenter.module.scss";

const ApplicationOrderBusinessCenter = ({ businessCenters = [], selectedBusinessCenter = [], handleChangeBusinessCenter, estateParent }) => {
	const { customer } = useSelector((state) => state.auth.user);

	const textItem = customer.use_sectors ? "Sectores" : "Centro de Costo";

	const handleAddRow = () => {
		let newBusinessCenter = [
			...selectedBusinessCenter,
			{
				value: "",
				label: "",
				specie: "",
				variety: "",
				area: 0,
				area_select: 0,
			},
		];

		handleChangeBusinessCenter(newBusinessCenter);
	};

	const handleRemoveRow = (index) => {
		const updated = selectedBusinessCenter.filter((_, i) => i !== index);
		handleChangeBusinessCenter(updated);
	};

	const handleSelectChange = (selected, index) => {
		if (!selected) return;

		const updated = [...selectedBusinessCenter];
		updated[index] = {
			...selected,
			area_select: Number(String(selected.area).replace(",", ".")) || 0,
		};
		handleChangeBusinessCenter(updated);
	};

	const handleHaUsedChange = (e, index) => {
		let value = e.target.value;
		value = value ? String(value).replaceAll(".", "") : "0";

		const parts = value.split(",");
		if (parts.length > 2) {
			value = parts[0] + "," + parts.slice(1).join("");
		}

		const updated = [...selectedBusinessCenter];
		const total_area = Number(String(updated[index].area).replace(".", "").replace(",", "."));
		const select_area = Number(value.replace(".", "").replace(",", "."));

		if (isNaN(select_area)) {
			toast.error("Ingresa un número válido");
			return;
		}

		if (select_area > total_area) {
			toast.error("El área seleccionada no puede ser mayor que el total disponible");
			return;
		}

		updated[index] = {
			...updated[index],
			area_select: value,
		};

		handleChangeBusinessCenter(updated);
	};

	return (
		<div className={styles.wrapper}>
			<table className={styles.table}>
				<thead>
					<tr className={styles.headerRow}>
						<th style={{ width: "30%" }}>{textItem}</th>
						<th style={{ width: "18%" }}>
							<Leaf size={14} className="me-1" /> Especie
						</th>
						<th style={{ width: "18%" }}>
							<Sprout size={14} className="me-1" /> Variedad
						</th>
						<th style={{ width: "13%" }}>Hectáreas Total</th>
						<th style={{ width: "13%" }}>Hectáreas a Utilizar</th>
						<th style={{ width: "8%" }}></th>
					</tr>
				</thead>
				<tbody>
					{selectedBusinessCenter.map((row, index) => (
						<tr key={index} className={styles.bodyRow}>
							<td>
								<Select
									value={businessCenters.find((bc) => String(bc.value) === String(row.value)) || null}
									onChange={(val) => handleSelectChange(val, index)}
									options={businessCenters.filter((bc) => !selectedBusinessCenter.some((sc) => sc.value === bc.value))}
									placeholder="Seleccione"
									className={styles.select}
									classNames={{
										control: () => styles.selectControl,
										valueContainer: () => styles.selectValueContainer,
									}}
									components={{
										NoOptionsMessage,
									}}
								/>
							</td>
							<td style={{ textAlign: "center" }}>
								<CustomBadge variant="neutral">{row.specie || "-"}</CustomBadge>
							</td>
							<td style={{ textAlign: "center" }}>
								<CustomBadge variant="neutral">{row.variety || "-"}</CustomBadge>
							</td>
							<td style={{ textAlign: "center" }}>{formatMilesDecimalNew(row.area) ?? "-"}</td>
							<td>
								<input
									type="text"
									style={{ textAlign: "right" }}
									value={row && row.area_select ? formatMilesDecimalNew(String(row.area_select).replace(".", ",")) : ""}
									onChange={(e) => handleHaUsedChange(e, index)}
									className={styles.input}
									onKeyDown={decimalValidateNew}
								/>
							</td>
							<td style={{ textAlign: "center" }}>
								<CustomButton variant="ghost" size="sm" onClick={() => handleRemoveRow(index)} className={styles.removeButton}>
									<X size={16} className="inline-block" />
								</CustomButton>
							</td>
						</tr>
					))}
				</tbody>
				<tfoot>
					<tr>
						<td colSpan={3}>
							<div className={styles.footer}>
								<CustomButton variant="primary" size="md" onClick={handleAddRow} disabled={!estateParent} className={styles.addButton}>
									{!estateParent ? "Debe seleccionar la bodega" : `+ Agregar ${textItem}`}
								</CustomButton>
							</div>
						</td>
						<td className={styles.footer_text}>Total Ha</td>
						<td className={styles.totalCell} style={{ fontWeight: "bold", textAlign: "right" }}>
							{selectedBusinessCenter.length > 0
								? formatMilesDecimalNew(
										String(
											selectedBusinessCenter.reduce((sum, r) => sum + Number(String(r.area_select).replace(",", ".") || 0), 0),
										).replace(".", ","),
									)
								: "0"}
						</td>
						<td></td>
					</tr>
				</tfoot>
			</table>
		</div>
	);
};

export default ApplicationOrderBusinessCenter;
